import { api } from "../utils/AuthManager";

const PatchClientPackage = async (id, params) => {
  return api
    .patch(`/api/client_package/${id}/`, params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default PatchClientPackage;
